import { useTranslation } from '@lyearn/i18n';
import { Select, Stack, Typography } from '@lyearn/ui';
import { getSelectOptionLabel } from '@/components/Form/components/Select/getOptionLabel';
import { renderLargeOptionLabel } from '@/components/Form/components/Select/optionLabelRenderer';
import { renderLargeSelectValue } from '@/components/Form/components/Select/renderValue';
import { getSelectPopperComponent } from '@/modules/user-survey/components/ConditionBlock/utils/select';

import { picklistStyles } from '../styles';
import { ExternalEventProviderType } from '../types';

const PopperComponent = getSelectPopperComponent(250);

interface ProviderProps {
  disabled?: boolean;
  error?: string;
  providers: ExternalEventProviderType[];
  value?: string;
  onChange: (value: string) => void;
}
function SelectProvider({ disabled, error, providers, value, onChange }: ProviderProps) {
  const { t } = useTranslation();

  return (
    <Stack className="space-y-8" direction="col">
      <Typography className="ms-8" color="text-text-primary" variant="body-short-02">
        {t('Common:Provider')}
      </Typography>
      <Select
        disableClearable
        PopperComponent={PopperComponent}
        className={picklistStyles}
        disabled={disabled}
        error={Boolean(error)}
        getOptionLabel={getSelectOptionLabel}
        optionLabelRenderer={renderLargeOptionLabel}
        options={providers}
        placeholder={t('Common:Actions.Select')}
        renderValue={renderLargeSelectValue}
        size="large"
        value={value}
        onChange={onChange}
      />
      {error ? (
        <Typography className="ms-8" color="text-text-error" variant="body-short-03">
          {error}
        </Typography>
      ) : null}
    </Stack>
  );
}

export default SelectProvider;
